import { useEffect, useState } from 'react'
import { RefreshCw, X } from 'lucide-react'
import { registerSW, applyUpdate } from '../registerSW'
import './PwaUpdatePrompt.css'

// Toast obnovleniya PWA. Registriruet SW pri montirovanii; kogda gotov novyy SW —
// pokazyvaet nenavyazchivyy toast s knopkoy «Obnovit» (primenyaet i perezagruzhaet).
export default function PwaUpdatePrompt() {
  const [reg, setReg] = useState(null)

  useEffect(() => {
    registerSW((registration) => setReg(registration))
  }, [])

  if (!reg) return null

  return (
    <div className="pwa-toast" role="alert" aria-live="polite">
      <RefreshCw size={16} className="pwa-toast-icon" />
      <span className="pwa-toast-text">Dostupno obnovlenie</span>
      <button className="pwa-toast-btn pwa-toast-primary" onClick={() => applyUpdate(reg)}>
        Obnovit
      </button>
      <button className="pwa-toast-btn pwa-toast-ghost" onClick={() => setReg(null)} title="Pozzhe">
        <X size={14} />
      </button>
    </div>
  )
}
